import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { WarningIcon } from "../svgs";

const CartAlertModal = ({
    background,
    hideModal,
    title,
    description,
    onOkClick = () => { }
}) => {
    const onCancelClick = () => {
        hideModal();
    }

    return (
        <ModalHolder>
            <div style={{
                background: '#fff',
                position: 'relative',
                padding: '30px',
                maxWidth: '480px',
                width: '90%',
                boxSizing: 'border-box',
                textAlign: 'center',
                borderRadius: '15px',
                fontFamily: 'MTNRegular'
            }}>
                <div>
                    <div>
                        <WarningIcon width={52} fill={background} />
                        <div
                            style={{ margin: '25px 0 15px 0', fontSize: '18px', fontFamily: 'MTNMedium' }}>
                            {title || 'Remove from cart'}
                        </div>
                        <div
                            style={{ margin: '0 0 25px 0', fontSize: '10px', color: '#7F7F7F', lineHeight: '150%', fontFamily: 'MTNRegular' }}>
                            {description || 'Are you sure you want to remove this item from your cart'}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <Button
                                onClick={onCancelClick}
                                bgColor={'#fff'}
                                textColor={background}
                                borderColor={background}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    onOkClick();
                                    hideModal();
                                }}
                                bgColor={background} textColor={'#fff'}
                                borderColor={background}>
                                Remove
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalHolder>
    )
}

const ModalHolder = ({ children }) => {
    return <div style={{
        position: 'absolute',
        zIndex: 100,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.7)'
    }}>
        <div style={{
            boxSizing: 'border-box',
            padding: '20px',
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {children}
        </div>
    </div>
}

const Button = styled.button`
    border-radius: 20px;
    border: ${({ borderColor }) => `2px solid ${borderColor}`};
    background-color: ${({ bgColor }) => `${bgColor}`};
    color: ${({ textColor }) => `${textColor}`};
    padding: 5px 10px;
    width: 100px;
    box-sizing: border-box;
    font-size: 14px;
`;

export default CartAlertModal;
